<template>
    <div>
    <!--begin::Dashboard-->
    
    <div class="row">
        <iframe src="/Cuadraturas/Bam" name="display-frame" style="width:100%; height:1100px; border:none;">
            
        </iframe>
        
      </div>
    <!--end::Dashboard-->
    </div>
</template>


<script>

import { mapState } from "vuex";
import { GET_USERS, DELETE_USER } from "@/core/services/store/user.module";
//import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
//import {Money} from 'v-money'

import { validationMixin } from "vuelidate";
import {
  minLength
} from "vuelidate/lib/validators";

import moment from 'moment'
moment.locale( 'es' );

export default {
  mixins: [validationMixin],
  name: "dashboard",
  components: {/*Money,*/},
  data() {
    return {
      dialog:false,
      tokenDelete:'',
      page: 1,
      pageCount: 0,
      itemsPerPage: 20,
      search: '',
      headers: [
        { text: 'Rut', value: 'rutUsuario'},
        { text: 'Nombre Cliente', value: 'nombres'},
        { text: 'Apellidos', value: 'apellidos' },
        { text: 'Empresa', value: 'nombres'},
        { text: 'Email', value: 'email' },
        {text:'Acciones'}
      ],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '$ ',
        suffix: '',
        precision: 0,
        masked: false
      },
      form: {
        documento: "",
        
        desde: "",
        hasta: ""
      },
    };
  },
  mounted () {
    this.getUsers();
  },
  validations: {
      form: {
        documento: {
          minLength: minLength(3)
        },
        desde: {
          
        },
        hasta: {

        }
      }
    },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.form = {
        documento: null,
        sucursal: null,
        desde: null,
        hasta: null
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    onButtonClick(item) {
      console.log('click on ' + item.no)
    },
    getUsers() {
      this.$Progress.start();
      this.$store
          .dispatch(GET_USERS, this.$store.state.auth.user)
          .then(()=>{this.$Progress.finish()});
    },
    confirmDelete(item){
      this.tokenDelete= item.tokenUsuario;
      this.dialog = true;
    },
    deleteClient() {
      this.$Progress.start();
      this.$store
          .dispatch(DELETE_USER, this.tokenDelete)
          .then(()=>{this.$Progress.finish(), this.getUsers(),this.dialog = false});
    }
  },
  filters:{
    formatDate(value) {
        const duration = moment(value).format('DD/MM/yyyy');
        return `${duration}`;
    },

    formatTime(value) {
        const hora = moment(value).format('HH:mm:ss');
        return `${hora}`;
    }
  },
  computed: {
    ...mapState({
      users : state => state.user.users,
      errors: state => state.errors,
      client: state => state.auth.user
    })
  }
};
</script>
<style>
.container {
    max-width: 1185px !important;
}
.b-form-datepicker {min-width:130px;}
.b-form-datepicker label {
        padding-bottom: 3px !important;
    padding-top: 6px;
    text-transform: none;
    white-space: nowrap !important;
    font-size: 1rem !important;
}
.b-form-datepicker .btn:not(:disabled):not(.disabled) {
    cursor: pointer;
    padding: 10px 5px;
}
.d-content-full{width:100%;}

.v-data-table .btn, .card-toolbar .btn {
  border-radius: 0;
     -webkit-box-shadow: none; 
     box-shadow: none; 
     padding: 7px 20px 6px 20px; 
     text-transform: uppercase;
}

.card.card-custom > .card-header {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: stretch;
    -ms-flex-align: stretch;
    align-items: stretch;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    min-height: 70px;
    padding-top: 0;
    padding-bottom: 0;
    background-color: transparent;
}

.card-header:first-child {
    border-radius: calc(0.42rem - 1px) calc(0.42rem - 1px) 0 0;
}
.pt-6, .py-6 {
    padding-top: 1.5rem !important;
}
.pb-0, .py-0 {
    padding-bottom: 0 !important;
}
.flex-wrap {
    -ms-flex-wrap: wrap !important;
    flex-wrap: wrap !important;
}
.border-0 {
    border: 0 !important;
}
.card-header {
    padding: 2rem 2.25rem;
    margin-bottom: 0;
    background-color: #ffffff;
    border-bottom: 1px solid #EBEDF3;
}
.btn.btn-primary {
    color: #FFFFFF;
    background-color: #3699FF;
    border-color: #3699FF;
}
.btn:not(.btn-text) {
    cursor: pointer;
}
.btn {
    outline: none !important;
    vertical-align: middle;
    -webkit-transition: color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, -webkit-box-shadow 0.15s ease;
    transition: color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, -webkit-box-shadow 0.15s ease;
    transition: color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
    transition: color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease, -webkit-box-shadow 0.15s ease;
}
.font-weight-bolder {
    font-weight: 600 !important;
}
.btn-primary {
    color: #ffffff;
    background-color: #3699FF;
    border-color: #3699FF;
    -webkit-box-shadow: none;
    box-shadow: none;
}
</style>
